import { createContext } from "react";

const reloadNothing = () => Promise.resolve();

const CarrierActivityReloadContext =
  createContext<() => Promise<void>>(reloadNothing);

export default CarrierActivityReloadContext;
